/*
Author: Liubo
Date: 2018-09-05
Desc: 业务组件mixin, 由各业务组件引用，用于网上交易/网站/APP/微信产品的业务组件机制，UMP不需要
*/
import compTitle from "@/components/layout/bizcompTitle.vue";
import log from "@/assets/js/log";
export default {
    components: {
        compTitle
    },
    props: {
        comp_code: String,
        comp_name: String,
        option: String
    },
    data () {
        return {
            title: "",
            charCate: false,
            className: "",
            compCate: ""
        };
    },
    methods: {
        prepareOption () {
            let optStr = this.option || "{}";
            let opt = {};
            try {
                opt = JSON.parse(optStr);
            } catch (ex) {
                this.$alert("业务组件[" + this.comp_name + "]的[option]格式错误", "", {
                    confirmButtonText: "确定",
                    type: "error"
                }).then(() => {
                    return false;
                }).catch(() => {
                    return false;
                });
            }
            for (let prop in opt) {
                this[prop] = opt[prop];
            }
        }
    },
    mounted () {
        log.info("加载业务组件[" + this.comp_code + "][" + this.comp_name + "]...");
        this.prepareOption();
    }
};
